var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGiftCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M397.1 32c-17.6 0-33.9 9-43.2 23.9l-45 72.1H320h80c26.5 0 48-21.5 48-48s-21.5-48-48-48h-2.9zm-130 96l-45-72.1C212.8 41 196.5 32 178.9 32H176c-26.5 0-48 21.5-48 48s21.5 48 48 48h80 11.1zM288 101l38.8-62c15.1-24.2 41.7-39 70.3-39H400c44.2 0 80 35.8 80 80c0 18-6 34.6-16 48h48c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V192c0-35.3 28.7-64 64-64h48c-10-13.4-16-30-16-48c0-44.2 35.8-80 80-80h2.9c28.6 0 55.2 14.7 70.3 39L288 101zM176 160H64c-17.7 0-32 14.3-32 32v96H544V192c0-17.7-14.3-32-32-32H400 322.2l58.1 69.8c5.7 6.8 4.7 16.9-2 22.5s-16.9 4.7-22.5-2L288 169l-67.7 81.3c-5.7 6.8-15.7 7.7-22.5 2s-7.7-15.7-2-22.5L253.8 160H176zM32 320v64H544V320H32zM544 448V416H32v32c0 17.7 14.3 32 32 32H512c17.7 0 32-14.3 32-32z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGiftCard);
export default __webpack_public_path__ + "static/media/gift-card.b823bff5d1c36e4a00690bb92b153b7e.svg";
export { ForwardRef as ReactComponent };